export default __webpack_public_path__ + "static/media/IconDesc_NitricAcid.256.eaa7b476.png";